module.exports = __webpack_public_path__ + "static/media/marija_stevic_major.a7bb0c79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/doctors/marija_stevic_major.jpg
// module id = 432
// module chunks = 0